import { SimpleGrid } from '@mantine/core';
import { InvestmentAllocationCard } from '@dealstack/frontend/app/pages/Project/MIP/MIPManage/InvestmentDetails/components/InvestmentDetailsContent/components/InvestmentAllocationCard/InvestmentAllocationCard.tsx';
import { InvestmentAllocationsProps } from '@dealstack/frontend/app/pages/Project/MIP/MIPManage/InvestmentDetails/components/InvestmentDetailsContent/components/InvestmentAllocations/InvestmentAllocations.types.ts';

type Props = InvestmentAllocationsProps;

export const InvestmentAllocationsCards = ({
	allocations,
	investmentType,
	canMutateAllocations,
	onEditAllocation,
}: Props) => {
	if (!allocations?.length) {
		return null;
	}

	return (
		<SimpleGrid cols={3} spacing="0.5rem">
			{allocations.map((allocation) => (
				<InvestmentAllocationCard
					key={allocation.id}
					allocation={allocation}
					investmentType={investmentType}
					canMutateAllocations={canMutateAllocations}
					onEditAllocation={onEditAllocation}
				/>
			))}
		</SimpleGrid>
	);
};
